import TravelDefaultSlider from '@/components/models/travel/sliders/TravelDefaultSlider'
import { Col, Container, Row } from 'react-bootstrap'
import { TitleH2 } from '@/components/cms/Title'

interface Props {
  title?: string
  travels: Array<any>
  sliderOptions?: any
  dotOptions?: any
}

const TravelSliderBanner = ({ title, travels, sliderOptions = {} }: Props) => {
  return (
    <>
      <Container fluid>
        <Row>
          <Col className="p-0 mb-5">
            {title && (
              <Container>
                <Row>
                  <Col>
                    <TitleH2 title={title} mb={0} />
                  </Col>
                </Row>
              </Container>
            )}
            {travels.length > 0 && <TravelDefaultSlider travels={travels} sliderOptions={sliderOptions} />}
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default TravelSliderBanner
